import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import _ from "lodash";
import { renderAsHTML } from "../../../../utils/html";
class Toast extends React.Component {
  constructor(props) {
    super(props);

    this.getBarStyle = this.getBarStyle.bind(this);
    this.getActionStyle = this.getActionStyle.bind(this);
    this.getTitleStyle = this.getTitleStyle.bind(this);
    this.handleClick = this.handleClick.bind(this);

    if (props.onDismiss && props.isActive) {
      this.dismissTimeout = setTimeout(props.onDismiss, props.dismissAfter);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dismissAfter === false) return;

    // See http://eslint.org/docs/rules/no-prototype-builtins
    if (!{}.hasOwnProperty.call(nextProps, "isLast")) {
      clearTimeout(this.dismissTimeout);
    }

    if (nextProps.onDismiss) {
      if (
        (nextProps.isActive && !this.props.isActive) ||
        (nextProps.dismissAfter && this.props.dismissAfter === false)
      ) {
        this.dismissTimeout = setTimeout(nextProps.onDismiss, nextProps.dismissAfter);
      }
    }
  }

  componentWillUnmount() {
    if (this.props.dismissAfter) clearTimeout(this.dismissTimeout);
  }

  /*
   * @description Dynamically get the styles for the bar.
   * @returns {object} result The style.
   */
  getBarStyle() {
    if (this.props.style === false) return {};

    const { isActive, barStyle, activeBarStyle } = this.props;

    return isActive ? { ...barStyle, ...activeBarStyle } : { ...barStyle };
  }

  /*
   * @function getActionStyle
   * @description Dynamically get the styles for the action text.
   * @returns {object} result The style.
   */
  getActionStyle() {
    return this.props.style !== false
      ? {
          padding: "0.125rem",
          marginLeft: "1rem",
          color: "#f44336",
          font: "0.75rem normal Roboto, sans-serif",
          lineHeight: "1rem",
          letterSpacing: "0.125ex",
          textTransform: "uppercase",
          borderRadius: "5px",
          cursor: "pointer",
          ...this.props.actionStyle,
        }
      : {};
  }

  /*
   * @function getTitleStyle
   * @description Dynamically get the styles for the title.
   * @returns {object} result The style.
   */
  getTitleStyle() {
    return this.props.style !== false
      ? {
          fontWeight: "700",
          marginRight: "0.5rem",
          ...this.props.titleStyle,
        }
      : {};
  }

  /*
   * @function handleClick
   * @description Handle click events on the action button.
   */
  handleClick() {
    if (this.props.onClick && typeof this.props.onClick === "function") {
      return this.props.onClick();
    }
  }

  render() {
    let baseClass = "apl-notification-bar";

    if (this.props.isActive) {
      baseClass += ` ${this.props.activeClassName}`;
    }
    if (this.props.className) {
      baseClass += ` ${this.props.className}`;
    }

    const { intl, title, action, message } = this.props;

    return (
      <div className={baseClass} style={this.getBarStyle()}>
        <div className="notification-bar-wrapper">
          {title && (
            <span className="notification-bar-title" style={this.getTitleStyle()}>
              {title}
            </span>
          )}
          <span className="notification-bar-message">
            {renderAsHTML("span", intl.formatMessage({ id: message, defaultMessage: message }))}
          </span>
          {action && (
            <span
              className="notification-bar-action"
              onClick={this.handleClick}
              style={this.getActionStyle()}
            >
              {_.isString(action)
                ? intl.formatMessage({
                    id: action,
                    defaultMessage: action,
                  })
                : action}
            </span>
          )}
        </div>
      </div>
    );
  }
}

Toast.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  action: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  style: PropTypes.bool,
  actionStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  barStyle: PropTypes.object,
  activeBarStyle: PropTypes.object,
  dismissAfter: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onDismiss: PropTypes.func,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  isActive: PropTypes.bool,
  title: PropTypes.string,
  intl: PropTypes.object,
};

Toast.defaultProps = {
  isActive: false,
  dismissAfter: 2000,
  activeClassName: "apl-notification-bar--active",
};

export default injectIntl(Toast);



// WEBPACK FOOTER //
// ./casper/sass/components/toast/toast.js